import React, { useEffect, useState } from 'react';
import { Colors, Text } from 'library';
import { styled, keyframes } from '@mui/material';
import TandemBlocksLogo from 'assets/images/tandem-blocks-logo.svg';

const messages = [
    'Finding teachers near you…',
    'Checking credentials & background checks…',
    'Looking for the best fit…',
    'Almost there…',
];

export default function FindingTeachersLoader({ zipCode }: { zipCode: string }) {
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % messages.length);
        }, 2400);
        return () => clearInterval(interval);
    }, []);

    return (
        <Container>
            <LogoBounce>
                <TandemBlocksLogo htmlColor={Colors.darkNavy} style={{ height: 64, width: 64 }} />
            </LogoBounce>
            <Text variant="h1" bold textStyle={{ color: Colors.darkNavy, marginTop: 28, textAlign: 'center' }}>
                {messages[messageIndex]}
            </Text>
            <Text variant="body1" textStyle={{ color: Colors.darkGrey, marginTop: 8, textAlign: 'center' }}>
                Searching near {zipCode}
            </Text>
            <DotRow>
                <Dot delay={0} />
                <Dot delay={0.2} />
                <Dot delay={0.4} />
            </DotRow>
        </Container>
    );
}

const bounce = keyframes`
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-16px); }
`;

const pulse = keyframes`
    0%, 100% { opacity: 0.3; transform: scale(0.8); }
    50% { opacity: 1; transform: scale(1); }
`;

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 20px',
    width: '100%',
});

const LogoBounce = styled('div')({
    animation: `${bounce} 1.4s ease-in-out infinite`,
});

const DotRow = styled('div')({
    display: 'flex',
    gap: 8,
    marginTop: 24,
});

const Dot = styled('div')<{ delay: number }>(({ delay }) => ({
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: Colors.turquoise,
    animation: `${pulse} 1.4s ease-in-out infinite`,
    animationDelay: `${delay}s`,
}));
